import { useMutation, useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';

export const useGetNewEstimateNumber = () => {
    const {mutateAsync, isLoading} = useMutation({
        mutationFn: async () => {
            return await apiClient.get('ee-tool/new-estimate-number') as string
        },
    });

    return {
        mutateAsync, isLoading
    }
}
